import { ScopeOverviewResponse } from '@ydistri/api-sdk';
import React, { useCallback } from 'react';
import ArchivedEntityListIcon from '../../../../components/domain/EntityLists/ArchivedEntityListIcon';
import ScopeSharingIcon from '../../../../components/domain/Scopes/ScopeSharingIcon';
import AdministrationItemCardPopoverContent from '../../common/AdministrationItemCardPopoverContent';
import AdministrationItemsList from '../../common/catalog/AdministrationItemsList';
import type { AdministrationItemsListItemProps } from '../../common/catalog/AdministrationItemsList';

interface ScopesListProps {
  data: ScopeOverviewResponse[];
  selectedScopeId?: number;
  selectionUrl: (scopeId: number) => string;
}

const ScopesList: React.FC<ScopesListProps> = ({ data, selectedScopeId, selectionUrl }) => {
  const getItemProps = useCallback(
    (scope: ScopeOverviewResponse): AdministrationItemsListItemProps => ({
      recordId: scope.scopeId,
      link: selectionUrl(scope.scopeId),
      selected: scope.scopeId === selectedScopeId,
      isArchived: scope.isArchived,
      cardProps: {
        name: scope.name,
        updatedAt: scope.updatedAt,
        updatedAtPopoverContent: <AdministrationItemCardPopoverContent item={scope} />,
        countable: [{ count: scope.sectionCount, description: 'section' }],
        archiveIndicator: scope.isArchived ? (
          <ArchivedEntityListIcon content="This Scope is archived." />
        ) : undefined,
        avatar: <ScopeSharingIcon isShared={scope.isShared} />,
      },
    }),
    [selectedScopeId, selectionUrl],
  );

  return (
    <AdministrationItemsList<ScopeOverviewResponse>
      data={data}
      getItemProps={getItemProps}
      $width="42rem"
      data-testid="ScopesList"
    />
  );
};

export default ScopesList;
